export const sharedTestIds = {
  layout: {
    headerLogo: 'layout.header-logo',
    maicApp: 'layout.maic-app',
    asideLeft: 'layout.aside-left',
    asideRight: 'layout.aside-right',
    sidepanelFlyover: <T extends string = string>(side: T) => `layout.sidepanel-flyover.${side}` as const,
    toggleSidepanelButton: <T extends string = string>(side: T) => `layout.toggle-sidepanel-button.${side}` as const,
    dropdownFloatingOverlay: 'layout.dropdown-floating-overlay',
    selectBox: 'layout.select-box',
  },

  select: {
    entry: <T extends number | string = number | string>(id: T) => `select.entry.${id}` as const,
  },

  welcome: {
    overlay: 'welcome.overlay',
    overlayDismiss: 'welcome.overlay-dismiss',
  },

  nav: {
    tab: <T extends number = number>(index: T) => `nav.tab.${index}` as const,
    textInput: 'nav.text-input',
    checkboxes: 'nav.checkboxes',
    selects: 'nav.selects',
    cosima: 'nav.cosima',
    redux: 'nav.redux',
    gallery: 'nav.gallery',
    accessibilityButton: 'nav.accessibility-button',
  },
  filter: {
    sidebarSearch: 'filter.sidebar-search',
    sidebarSearchClearButton: 'filter.sidebar-search-clear-button',
    favoritesButton: 'filter.favorites-button',
    editedButton: 'filter.edited-button',
  },
  favorites: {
    setSelector: 'favorites.set-selector',
    setCheckbox: 'favorites.set-checkbox',
    setItem: <T extends string = string>(name: T) => `favorites.set-item.${name}` as const,
    createNewSetButton: 'favorites.create-new-set-button',
    showExportModal: 'favorites.show-export-modal',
    showImportModal: 'favorites.show-import-modal',
    importModal: 'favorites.import-modal',
    importButton: 'favorites.import-button',
    importModalButton: 'favorites.import-modal-button',
    exportButton: 'favorites.export-button',
    mappingSelect: 'favorites.mapping-select',
    backButton: 'favorites.back-button',
    cancelButton: 'favorites.cancel-button',
  },

  userSettings: {
    dropdown: 'user-settings.dropdown',
    zoom: {
      segmentedButton: 'user-settings.zoom.segmented-button',
      regular: 'user-settings.zoom.regular',
      large: 'user-settings.zoom.large',
      extraLarge: 'user-settings.zoom.extra-large',
    },
    viewportSize: {
      segmentedButton: 'user-settings.viewport-size.segmented-button',
      regular: 'user-settings.viewport-size.regular',
      wide: 'user-settings.viewport-size.wide',
      ultraWide: 'user-settings.viewport-size.ultra-wide',
    },
    contrastThemeSelect: 'user-settings.contrast-theme-select',
    sidepanelsBehaviorSelect: 'user-settings.sidepanels-behavior-select',
    languageSelect: 'user-settings.language-select',
    languageOption: <T extends string = string>(locale: T) => `user-settings.language-select-${locale}` as const,
    goToTechnicalSetup: 'user-settings.go-to-technical-setup',
  },

  systemInfo: {
    showOverlayButton: 'system-info.show-overlay-button',
    showUserDropdown: 'system-info.show-user-dropdown',
    overlay: 'system-info.overlay',
    copyToClipboardButton: 'system-info.copy-to-clipboard.button',
    copyToClipboardToast: 'system-info.copy-to-clipboard.toast',
    downloadJsonButton: 'system-info.download-json-button',
    entryByTitle: 'system-info.entry.title',
    entryByValue: 'system-info.entry.value',
    tab: <T extends string = string>(id: T) => `system-info.tab.${id}` as const,
  },

  debugSettings: {
    popupButton: 'debug-settings.popup-button',
    popup: 'debug-settings.popup',
    popupCloseButton: 'debug-settings.popup-close-button',
    bridgeButton: 'debug-settings.bridge-button',
  },

  feedback: {
    element: 'feedback.dropdown',
    reportFormDescriptionInput: 'feedback.report-form-description-input',
  },

  grid: {
    virtualizedGridScrollList: 'grid.virtualized-grid-scroll-list',
    markerTrackIndicator: 'grid.marker-track-indicator',
  },

  optionTree: {
    group: <T extends string = string>(id: T) => `option-tree.group.${id}` as const,
    groupTitle: 'option-tree.group.title',
    subgroup: <T extends string = string>(id: T) => `option-tree.subgroup.${id}` as const,
    subgroupTitle: 'option-tree.subgroup.title',
  },

  printOptions: {
    showOptionsButton: 'print.show-options-button',
    toggleHideInPrint: 'print.toggle-hide-in-print',
    toggleEmphasizeInPrint: 'print.toggle-emphasize-in-print',
    toggleDescriptionInPrint: 'print.toggle-description-in-print',
    toggleImageInPrint: 'print.toggle-image-in-print',
  },

  error: {
    page: 'error.page',
    reportDialog: 'error.report-dialog',
    reportButton: 'error.report-button',
  },

  referenceTruck: {
    card: 'reference-truck.card',
  },
} as const
